import { render, staticRenderFns } from "./SatisfactionCard.vue?vue&type=template&id=8d4f4544"
import script from "./SatisfactionCard.vue?vue&type=script&lang=js"
export * from "./SatisfactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports